<demo-section [name]="name" [src]="src" [componentContent]="componentContent">
    <p>Single selection in a set of options</p>
    <docs-section [content]="componentContent"></docs-section>
</demo-section>
  